(function () {
	const PERIOD_MS = 12 * 60 * 60 * 1000;

	const hashString = (value) => {
		let hash = 2166136261;
		for (let index = 0; index < value.length; index += 1) {
			hash ^= value.charCodeAt(index);
			hash = Math.imul(hash, 16777619);
		}
		return hash >>> 0;
	};

	const getGrowth = (productId, periods) => {
		let growth = 0;
		for (let period = 0; period < periods; period += 1) {
			growth += 30 + (hashString(`${productId}:${period}`) % 21);
		}
		return growth;
	};

	const updateSalesCounters = () => {
		document.querySelectorAll("[data-sales-growth]").forEach((counter) => {
			const output = counter.querySelector("[data-sales-total]");
			const base = Number.parseInt(counter.dataset.salesBase, 10);
			const start = Date.parse(counter.dataset.salesStart);
			const productId = counter.dataset.salesProductId || "product";

			if (!output || !Number.isFinite(base) || !Number.isFinite(start)) return;

			const periods = Math.max(0, Math.floor((Date.now() - start) / PERIOD_MS));
			const total = base + getGrowth(productId, periods);
			output.textContent = `${new Intl.NumberFormat(document.documentElement.lang || "en").format(total)} sold`;
		});
	};

	document.addEventListener("DOMContentLoaded", updateSalesCounters);
	document.addEventListener("shopify:section:load", updateSalesCounters);
	window.setInterval(updateSalesCounters, 60 * 1000);
})();
